// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

const homeAnimations = new function () {
    let elements = []
    let currentLenis = null;

    const tickLenis = (time) => {
        currentLenis.raf(time * 1000);
    }
    
    this.init = () => {

        if (document.querySelector('.ss-home')) {
            const wrapperEl = document.querySelector('#ss-page');
            
            currentLenis = new Lenis({
                lerp: 0.1,
                wrapper: wrapperEl, // FIX ISSUES IN SAFARI
                eventsTarget: wrapperEl, // FIX ISSUES IN SAFARI
                syncTouch: true,
                // syncTouchLerp: 0.2
            });

            // console.log(window.AN.VARS.curtains);
            currentLenis.on('scroll', (e) => {
                ScrollTrigger.update()
            })

            gsap.ticker.add(tickLenis);
            gsap.ticker.lagSmoothing(0);

            const pinEl =  document.querySelector(".fixed-container");
            const elLottie1 = document.querySelector('.js-lottie-1');
            const elLottie2 = document.querySelector('.js-lottie-2');
            const wrapperLotties = document.querySelector('.js-wrapper-lotties');
            const parentElement = pinEl.parentElement;
            const vh = window.innerHeight/100;

            const sec7 = document.querySelector('.ss-section--7');
            const sec7Bg = sec7.querySelector('.ss-section__bg');

            gsap.set(sec7Bg, { autoAlpha:0 })
            gsap.set(elLottie2, { autoAlpha:0 })
            gsap.set(elLottie2, { autoAlpha:0 })

            // in VH
            const lottie1End = 20;

            const lottie2Start = lottie1End;
            const lottie2Duration = 300;
            const lottie2End = lottie2Start + lottie2Duration;

            const lottie3Start = lottie2End;
            const totalDuration = lottie3Start;

            gsap.set(wrapperLotties, { '--total-duration': totalDuration })

            ScrollTrigger.create({
                trigger: parentElement,
                start: "top top",
                end: () => `+=${totalDuration*vh}px`, // Ajusta la duración según sea necesario
                // scrub: true,
                pin: pinEl,
                // pinType: 'fixed',
                // markers: true,
                scroller: '#ss-page',
                // onLeave: () => elLottie1.classList.add('hide'),
                // onEnterBack: () => elLottie1.classList.remove('hide'),
            });
            
            const elLottie1Json = elLottie1.dataset.json;
            if (elLottie1Json) {
                const lottie1Scene = lottie.loadAnimation({
                    container: elLottie1,
                    loop: false,
                    autoplay: false,
                    renderer: 'svg',
                    path: elLottie1Json,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice'
                    }
                });
    
                elements.push({
                    el: elLottie1,
                    animation: lottie1Scene
                });

                lottie1Scene.addEventListener("data_ready", () => {
                    lottie1Scene.play();
                });
            }

            const elLottie2Json = elLottie2.dataset.json;
            if (elLottie2Json) {
                const lottie2Scene = lottie.loadAnimation({
                    container: elLottie2,
                    loop: false,
                    autoplay: false,
                    renderer: 'svg',
                    path: elLottie2Json,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice'
                    }
                });
    
                elements.push({
                    el: elLottie2,
                    animation: lottie2Scene
                });

                lottie2Scene.addEventListener("data_ready", () => {
                    let playhead = { frame: 0 };
                    gsap.to(playhead, {
                        frame: lottie2Scene.totalFrames - 1,
                        ease: "none",
                        onUpdate: () => lottie2Scene.goToAndStop(playhead.frame, true),
                        scrollTrigger: {
                            trigger: parentElement,
                            start: `top+=${lottie2Start*vh}px top`,
                            end: () => `+=${lottie2Duration*vh}px`, // Ajusta la duración según sea necesario
                            scrub: true,
                            // markers: true,
                            scroller: '#ss-page',
                            onEnter() {
                                // console.log('onEnter');
                                gsap.set(elLottie1, { autoAlpha:0 })
                                gsap.set(elLottie2, { autoAlpha:1 })
                                gsap.set(sec7Bg, { autoAlpha:0 })
                            },
                            onLeave() {
                                gsap.set(elLottie1, { autoAlpha:0 })
                                gsap.set(elLottie2, { autoAlpha:0 })
                                gsap.set(sec7Bg, { autoAlpha:1 })
                                // console.log('onLeave');
                            },
                            onLeaveBack: () => {
                                // console.log('onLeaveBack');
                                gsap.set(elLottie1, { autoAlpha:1 })
                                gsap.set(elLottie2, { autoAlpha:0 })
                                gsap.set(sec7Bg, { autoAlpha:0 })
                            },
                            onEnterBack() {
                                gsap.set(elLottie1, { autoAlpha:0 })
                                gsap.set(elLottie2, { autoAlpha:1 })
                                gsap.set(sec7Bg, { autoAlpha:0 })
                                // console.log('onEnterBack');
                            },
                        }
                    });
                });
            }
        
            if (sec7) {
                let sectionCnt = sec7.querySelector('.ss-section__cnt');
                let sectionHeight = sectionCnt.scrollHeight;
                let container = sec7.querySelector('.home-animation--loop');

                if (container) {
                    
                    const animDataUrl = container.dataset.json;
                    if (animDataUrl) {
                        const anim = lottie.loadAnimation({
                            container: container,
                            loop: true,
                            autoplay: false,
                            renderer: 'svg',
                            path: animDataUrl,
                            rendererSettings: {
                                preserveAspectRatio: 'xMidYMid slice'
                            }
                        });

                        elements.push({
                            el: container,
                            animation: anim
                        });

                        ScrollTrigger.create({
                            trigger: parentElement,
                            start: `top+=${lottie3Start*vh} top`,
                            // markers: true,
                            scroller: '#ss-page',
                            onEnter() {
                                // console.log('onEnter');
                                // container.classList.remove('hide');
                                anim.goToAndPlay(0, true)
                            },
                            // onLeave: () => {
                            //     console.log('onLeave');
                            //     // anim.pause()
                            // },
                            // onEnterBack() {
                            //     console.log('onEnterBack');
                            //     anim.play()
                            // },
                            onLeaveBack: () => {
                                // console.log('onLeaveBack');
                                anim.pause()
                            },
                        });
                    }
                }
            }

        }
        

    };
    
    this.kill = () => {
        elements.forEach(element => {
            element.animation.destroy();
            ScrollTrigger.kill(element.el);
        });

        if(!!currentLenis){
            currentLenis.destroy();
            //to remove the listener later...
            gsap.ticker.remove(tickLenis);
            currentLenis = null;
        }
    };

}

export default homeAnimations